import React, { useEffect, useState } from "react";
import "rc-color-picker/assets/index.css";

import ColorPicker from "rc-color-picker";

import {
  SimpleForm,
  useDataProvider,
  SaveButton,
  Toolbar,
  useNotify,
  useInput,
} from "react-admin";
import FileProvider from "../../Providers/FileProvider";

import MockHome from "../../Layout/Theme/MockHome";
import { setTheme } from "../../Reducers/General";
import { useDispatch } from "react-redux";
import {
  PageContainer,
  Content,
  HeaderRow,
  Title,
  Subtitle,
  MainGrid,
  Card,
  SectionTitle,
  SectionHint,
  FormStack,
  ColorRow,
  PreviewCard,
  UploadWrapper,
  SidebarCard,
} from "./styles";
import ImageUpload from "../../Components/ImageUpload";
const Dashboard = (props: any) => {
  const dispatch = useDispatch();

  const [crop, setCrop] = useState<File>();
  const [data, setData] = useState<any>({});
  const dataProvider = useDataProvider();
  const getData = React.useCallback(() => {
    dataProvider
      .getOne("theme", { id: 1 })
      .then((res: any) => {
        if (res) {
          setData(res.data);
          dispatch(
            setTheme({
              primary: res.data.primary,
              secondary: res.data.secondary,
              cover: res.data.cover.url,
            })
          );
        }

      })
      .catch((error: any) => {
        //console.log(error);
      });
  }, [dataProvider, setData]);

  useEffect(() => {
    getData();
  }, [getData]);

  const PostCreateToolbar = (props: any) => {
    const dataProvider = useDataProvider();
    const notify = useNotify();

    const handleUpload = async (file: any) => {
      //setLoading(true);
      const result = await FileProvider().create(file);
      return result;
    };

    return (
      <Toolbar {...props}>
        <SaveButton
          label="Salvar"
          onSave={async (data: any) => {
            if (crop) {
              data.cover = await handleUpload(crop);
            }

            dataProvider
              .update("theme", { id: 1, data })
              .then((res: any) => {
                notify("Dados atualizados com sucesso!", "info");
              })
              .catch((error: any) => {
                //console.log(error);
              });
            return { ...data, notify: true };
          }}
          submitOnEnter={false}
        />
      </Toolbar>
    );
  };

  const CustomColorInput = (props: any) => {
    const {
      input: { name, onChange },
    } = useInput(props);

    const handleChange = (name, colors) => {
      onChange(colors.color);
      dispatch(setTheme({ [name]: colors.color }));
      //setThemeColors({ ...themeColors, [name]: colors.color });
    };

    return (
      <ColorPicker
        name={name}
        open={true}
        animation="slide-up"
        color={props.defaultValue}
        defaultColor={props.defaultValue}
        onChange={(colors: any) => handleChange(name, colors)}
      />
    );
  };

  const handleUpload = async (file: any) => {
    //setLoading(true);
    const result = await FileProvider().create(file);
    if (result?.url) {
      dispatch(setTheme({ cover: result?.url }));
    }

    return result;
  };


  return (
    <PageContainer>
      <SimpleForm toolbar={<PostCreateToolbar />}>
        <Content>
          <HeaderRow>
            <Title>Tema</Title>
            <Subtitle>Personalize cores e capa para combinar com sua marca.</Subtitle>
          </HeaderRow>

          <MainGrid>
            <PreviewCard className="preview">
              <MockHome />
            </PreviewCard>

            <SidebarCard className="sidebar">
              <SectionTitle>Cores</SectionTitle>
              <SectionHint>
                Selecione as cores principais do seu menu para combinar com sua
                identidade visual.
              </SectionHint>
              <FormStack>
                <ColorRow>
                  <label style={{ color: "#212121", fontSize: 16 }}>
                    Cor Primária
                  </label>
                  <CustomColorInput
                    source="primary"
                    defaultValue={data?.primary}
                  />
                </ColorRow>
                <ColorRow>
                  <label style={{ color: "#212121", fontSize: 16 }}>
                    Cor Secundária
                  </label>
                  <CustomColorInput
                    source="secondary"
                    defaultValue={data?.secondary}
                  />
                </ColorRow>
              </FormStack>

              <SectionTitle>Capa</SectionTitle>
              <UploadWrapper>
                <ImageUpload
                  source="cover"
                  onCropImage={async (image) => {
                    var request = await fetch(image);
                    var blob = await request.blob();
                    var file = new File([blob], "filename.jpg", {
                      type: "image/jpeg",
                    });
                    setCrop(file);
                  }}
                />
              </UploadWrapper>
            </SidebarCard>
          </MainGrid>
        </Content>
      </SimpleForm>
    </PageContainer>
  );
};

export default React.memo(Dashboard);
